// Mixin padrão para a tabela
import TabelaMixin from "@/shared/mixin/TabelaMixin";

// Service
import TabelaContatosExcluidosService from "./TabelaContatosExcluidosService";

export default {
  props: {
    listagemContatosExcluidos: {
      type: Array,
      default: () => [
        // {
        //   "cdUnimed": Number,
        //   "email": String,
        //   "id": Number,
        //   "nome": String,
        //   "notificacaoAtiva": Boolean,
        //   "telefone": String
        // }
      ]
    },
    loadingContatosExcluidos: {
      type: Boolean,
      default: false
    }
  },
  mixins: [TabelaMixin, TabelaContatosExcluidosService],
  data() {
    return {
      valoresSwitchData: [],
      cabecalho: [
        {
          texto: "Nome"
        },
        {
          texto: "Email"
        },
        {
          texto: "Usuário responsável"
        },
        {
          texto: "Data Exclusão"
        },
        {
          texto: "Motivo Exclusão"
        }
      ]
    };
  },
  methods: {
    /**
     * Método que é chamado na hora de escolher uma ação da tabela
     * @param {{ id: Number, acao: Number }} objetoAcao
     */
    escolherAcao(objetoAcao) {
      const { acao, id } = objetoAcao;
      const idAtual = this.rows[id].naoMostrar.id;

      switch (acao) {
        case 0:
          this.$emit("motivo-exclusao", idAtual);
          break;
        case 1:
          this.$emit("historico", idAtual);
          break;
      }
    }
  },
  watch: {
    listagemContatosExcluidos: {
      deep: true,
      handler() {
        this.rows = this.listagemContatosExcluidos.map(e => e);
      }
    },
    valoresSwitchProp: {
      deep: true,
      handler() {
        this.valoresSwitchData = this.valoresSwitchProp.map(e => e);
      }
    }
  }
};
